// Catálogo de reportes del Admin SureKeep (M6_OPERACIONES §5.2): definición y copy de cada reporte.
// `lakeTable` en `null` = ninguna tabla del lake lo sostiene todavía, y no se puede generar.
import type { ReportDefinition } from './types';

export const SK_REPORT_CATALOG: readonly ReportDefinition[] = [
    {
        reportId: 'RSK-01',
        name: 'Cartera total y activa',
        description: 'Saldo total, créditos activos, distribución por nivel',
        category: 'PORTFOLIO',
        periodicity: 'DAILY',
        reference: 'M2 §13.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-02',
        name: 'Cartera vencida por bucket',
        description: 'M30, M60, M90 y >90 días',
        category: 'PORTFOLIO',
        periodicity: 'DAILY',
        reference: 'M2 §13.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-03',
        name: 'Indicadores M30/M60/M90',
        description: 'Índice de mora por bucket con evolución',
        category: 'PORTFOLIO',
        periodicity: 'MONTHLY',
        reference: 'M2 §13.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-04',
        name: 'Cosecha (vintage)',
        description: 'Comportamiento por mes de originación',
        category: 'PORTFOLIO',
        periodicity: 'MONTHLY',
        reference: 'M2 §13.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-05',
        name: 'Originación del período',
        description: 'Créditos nuevos, monto, nivel promedio',
        category: 'PORTFOLIO',
        periodicity: 'WEEKLY',
        reference: 'M2 §13.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-06',
        name: 'Cobranza por canal',
        description: 'PCF automático, app manual, tienda, OXXO',
        category: 'COLLECTIONS',
        periodicity: 'WEEKLY',
        reference: 'M4 §8.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-07',
        name: 'Rendimiento por cobrador',
        description: 'Contactos, compromisos, cobros, efectividad',
        category: 'COLLECTIONS',
        periodicity: 'WEEKLY',
        reference: 'M4 §8.2, §8.4',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-08',
        name: 'Bajas contables y recuperación',
        description: 'Créditos dados de baja, monto y recuperaciones post-baja',
        category: 'ACCOUNTING',
        periodicity: 'MONTHLY',
        reference: 'M4 §8.2',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-09',
        name: 'Efectividad de bloqueo',
        description: 'Dispositivos bloqueados y desbloqueados por pago',
        category: 'COLLECTIONS',
        periodicity: 'MONTHLY',
        reference: 'M4 §8.3',
        regulatoryMandatory: false,
        lakeTable: null,
    },
    {
        reportId: 'RSK-10',
        name: 'Reporte a Buró · Círculo de Crédito',
        description: 'Créditos en mora >30 días vía GSF',
        category: 'REGULATORY',
        periodicity: 'MONTHLY',
        reference: 'M2 §13.2 · GSF',
        regulatoryMandatory: true,
        lakeTable: null,
    },
];
